// extracted by mini-css-extract-plugin
export var gif = "_ff-0";